import { render, staticRenderFns } from "./CompetenceUnitForm.vue?vue&type=template&id=f5699764&scoped=true"
import script from "./CompetenceUnitForm.vue?vue&type=script&lang=js"
export * from "./CompetenceUnitForm.vue?vue&type=script&lang=js"
import style0 from "./CompetenceUnitForm.vue?vue&type=style&index=0&id=f5699764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5699764",
  null
  
)

export default component.exports